/* Approximate prices in the visitor's currency, for display only: the shop always charges in UYU.
   Rates come from Shopify's /services/javascripts/currencies.js (window.Currency.rates, USD value of 1 unit).
   If that script is missing or lacks a currency, prices stay in pesos. Imports cleanly in Node: the DOM is
   only touched when `document` exists. Any module that inserts HTML with prices dispatches "jc:prices". */

// order and mapping as in the mockup (FX, CUR_OF, EURO in docs/design/maqueta.html)
export const CURRENCIES = "UYU USD EUR ARS BRL CLP PYG PEN COP MXN BOB GBP CHF CAD AUD NZD JPY CNY KRW INR SEK NOK DKK ZAR ILS".split(" ");
const CUR_OF = { UY: "UYU", AR: "ARS", BR: "BRL", CL: "CLP", PY: "PYG", PE: "PEN", CO: "COP", MX: "MXN", BO: "BOB", GB: "GBP", CH: "CHF", LI: "CHF", CA: "CAD", AU: "AUD", NZ: "NZD", JP: "JPY", CN: "CNY", KR: "KRW", IN: "INR", SE: "SEK", NO: "NOK", DK: "DKK", ZA: "ZAR", IL: "ILS" };
const EURO = "AD AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MC ME MT NL PT SI SK SM VA AX GF GP MQ RE YT BL MF PM".split(" ");

export const currencyOf = country => CUR_OF[country] || (EURO.includes(country) ? "EUR" : "USD");

export function convertLabel(uyuCents, code, rates, lang) {
  if (code === "UYU" || !rates?.UYU || !rates[code]) return null;
  const v = uyuCents / 100 * rates.UYU / rates[code];
  const step = v >= 10000 ? 100 : v >= 1000 ? 10 : 1;
  return code + " " + (Math.round(v / step) * step).toLocaleString(lang === "es" ? "es-UY" : "en-US");
}

const rates = () => (typeof window !== "undefined" ? window.Currency?.rates : null) || {};
const stored = key => { try { return localStorage.getItem(key); } catch { return null; } };
const hasRate = code => code === "UYU" ? true : Boolean(rates()[code] && rates().UYU);

export function currentCurrency() {
  const saved = stored("jc-currency");
  if (saved && hasRate(saved)) return saved;
  // a country whose currency has no rate (or no rates at all) shows pesos, never a currency the prices are not in
  const code = currencyOf(stored("jc-country") || document.documentElement.dataset.country);
  return hasRate(code) ? code : "UYU";
}

export function repaintPrices(root = document) {
  const code = currentCurrency();
  const lang = document.documentElement.lang.startsWith("en") ? "en" : "es";
  root.querySelectorAll("[data-uyu]").forEach(el => {
    // keep the pesos text the server (or product-form.js) wrote, to go back to it
    el.dataset.pesos ??= el.textContent;
    el.textContent = convertLabel(Number(el.dataset.uyu), code, rates(), lang) ?? el.dataset.pesos;
  });
}

function wirePicker() {
  const selects = document.querySelectorAll(".foot .curSel");
  selects.forEach(select => {
    // only offer currencies with a rate; a picker with nothing but UYU is pointless
    [...select.options].forEach(o => { if (!hasRate(o.value)) o.remove(); });
    if (select.options.length < 2) select.closest(".cur-pick")?.setAttribute("hidden", "");
    select.value = currentCurrency();
    select.closest("jc-select")?.sync?.();
    select.addEventListener("change", () => {
      try { localStorage.setItem("jc-currency", select.value); } catch {}
      selects.forEach(s => { s.value = select.value; s.closest("jc-select")?.sync?.(); });
      repaintPrices();
    });
  });
}

if (typeof document !== "undefined") {
  wirePicker();
  repaintPrices();
  document.addEventListener("jc:prices", () => repaintPrices());
}

// The language switch keeps the whole URL: Liquid cannot see the query string, so on submit the return_to
// becomes the current path (without the current locale prefix, Shopify adds the target's) plus the full query.
if (typeof document !== "undefined") {
  document.addEventListener("submit", event => {
    const field = event.target.querySelector?.('input[name="return_to"]');
    if (!field || !event.target.matches(".lang-form")) return;
    const prefix = "/" + document.documentElement.lang.split("-")[0];
    let path = location.pathname;
    if (path === prefix || path.startsWith(prefix + "/")) path = path.slice(prefix.length) || "/";
    field.value = path + location.search;
  });
}
